// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Unverified_wrapper__iDjbn","link":"Unverified_link__2mpss"};